
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","stroke":"#798F8F","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke-linecap":"round","d":"M5.5 2.5h9m-9 6h9m-9 6h9"}}),_c('circle',{attrs:{"cx":"2.5","cy":"2.5","r":".5"}}),_c('circle',{attrs:{"cx":"2.5","cy":"8.5","r":".5"}}),_c('circle',{attrs:{"cx":"2.5","cy":"14.5","r":".5"}})])
          )
        }
      }
    